import {
  fetchPublisherSettings,
  updatePublisherSettings,
} from '../../shared/utils/api';
import {
  FETCH_SETTINGS_REQUEST,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAIL,
  SAVE_SETTINGS_REQUEST,
  SAVE_SETTINGS_SUCCESS,
  SAVE_SETTINGS_FAIL,
} from '../../store/types';
import { UI_MESSAGES } from '../../shared/constants';
import { extractContractError } from  '@bafkal/ui-shared/utils';

export const loadSettings = () => async (dispatch) => {
  dispatch({ type: FETCH_SETTINGS_REQUEST });
  try {
    const data = await fetchPublisherSettings();
    dispatch({ type: FETCH_SETTINGS_SUCCESS, payload: data });
    return data;
  } catch (err) {
    // 404 means settings not yet configured — treat as empty defaults
    if (err?.response?.status === 404) {
      dispatch({ type: FETCH_SETTINGS_SUCCESS, payload: null });
      return null;
    }
    const contractError = extractContractError(err, UI_MESSAGES.SETTINGS.FETCH_FAILED);
    dispatch({ type: FETCH_SETTINGS_FAIL, payload: contractError });
    throw err;
  }
};

export const saveSettings = (data) => async (dispatch) => {
  dispatch({ type: SAVE_SETTINGS_REQUEST });
  try {
    const result = await updatePublisherSettings(data);
    dispatch({ type: SAVE_SETTINGS_SUCCESS, payload: result });
    return result;
  } catch (err) {
    const contractError = extractContractError(err, UI_MESSAGES.SETTINGS.SAVE_FAILED);
    dispatch({ type: SAVE_SETTINGS_FAIL, payload: contractError });
    throw err;
  }
};
